<template>
  <div style="width: 1080px; height: 60px; margin: 0 auto;">
    <div id="logo-wrap">
      <img id="logo" src="../assets/images/logo.jpg" />
      <div class="web-title">海南省文联维权服务系统</div>
    </div>
    <div id="menu-wrap">
      <Menu mode="horizontal">
          <MenuItem name="1" :to="{path: '/'}"><Icon type="ios-paper" />首页</MenuItem>

          <MenuItem name="2" :to="{path: '/article/list', query: {category: 'classic_case', code: Math.random()}}">
            <Icon type="ios-book" />
            典型案例
          </MenuItem>
          <MenuItem name="3" :to="{path: '/article/list/report', query: {category: 'work_briefing', code: Math.random()}}">
          <Icon type="ios-stats" />
            工作简报
          </MenuItem>
          <!-- <MenuItem name="4" :to="{path: '/question/list', query: {}}">
          <Icon type="ios-videocam" />
            维权咨询
          </MenuItem> -->

          <Submenu name="4">
            <template #title>
              <Icon type="ios-videocam" />
              维权咨询
            </template>
            <MenuGroup title="使用">
              <MenuItem name="4-1" :to="{path: '/question/list', query: {}}">咨询列表</MenuItem>
              <MenuItem name="4-2" :to="{path: '/question/add', query: {}}">咨询提交</MenuItem>
              <MenuItem name="4-3" :to="{path: '/robot/talking', query: {}}">在线机器人维权</MenuItem>
            </MenuGroup>
          </Submenu>


          
          <Submenu name="5" v-if="user!=null">
            <template #title>
              <Icon type="ios-people" />
              投诉举报
            </template>
            <MenuGroup title="投诉举报">
              <MenuItem name="5-1" :to="{path: '/complaint/apply/add', query: {}}">投诉举报</MenuItem>
              <MenuItem name="5-2" :to="{path: '/complaint/apply/mine', query: {}}">我的投诉</MenuItem>
            </MenuGroup>
          </Submenu>
          <MenuItem name="5" v-else :to="{path: '/complaint/apply/add', query: {}}">
          <Icon type="ios-videocam" />
            投诉举报
          </MenuItem>
          
          <Submenu name="6" v-if="user!=null">
            <template #title>
              <Icon type="ios-people" />
              用户
            </template>
            <MenuGroup title="使用">
              <MenuItem name="6-1" :to="{path: '/admin/question/all', query: {}}">问题审核</MenuItem>
              <MenuItem name="6-2" :to="{path: '/admin/complaint/apply/all', query: {}}">投诉审核</MenuItem>
              <MenuItem name="6-3" :to="{path: '/admin/article/add', query: {}}">文章发布</MenuItem>
              <MenuItem name="6-4" :to="{path: '/admin/article/all', query: {}}">文章管理</MenuItem>
            </MenuGroup>
            <MenuGroup title="用户">
              <MenuItem name="6-5" @click="logout" >退出登录</MenuItem>
            </MenuGroup>
          </Submenu>
          <MenuItem name="6" v-else>
            <a href="http://124.193.99.194/rts/web/rts-oauth2/Login?client_id=1677032180838_4172611e55d9&redirect_uri=http%3A%2F%2Fright.cspaxy.com%2F%23%2Fuser%2Flogin&response_type=code&state=">
            <!--<a href="http://10.1.88.55/rts/web/rts-oauth2/Login?client_id=1677032180838_4172611e55d9&redirect_uri=http%3A%2F%2F10.1.88.59:81%2F%23%2Fuser%2Flogin&response_type=code&state=">-->
            <!--<a href="http://124.193.99.194/rts/web/rts-oauth2/Login?client_id=1677032180838_4172611e55d9&redirect_uri=http%3A%2F%2Flocalhost:8081%2F%23%2Fuser%2Flogin&response_type=code&state=">-->
              <Icon type="ios-people" />
              用户登录
            </a>
          </MenuItem>
        </Menu>
    </div>
  </div>
  <div id="header-sep"></div>
</template>
<script>
export default {
  components: {
    
  },

  data () {
      return {
        user: null
      }
    },
    mounted() {
    this.initUser()
  },
  methods: {
      //初始化用户信息
      initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        }
      },
      //退出登录
      logout() {
        localStorage.removeItem("user")
        this.user=null
      }
  }
}
</script>


